import React from "react";
import PropTypes from "prop-types";
import Link from "../shared/Link";

/**
 * FedRamp Header Filter
 * @param {Object} props
 * @param {"All" | "Product" | "Provider"} props.searchFilter
 * @param {function} props.setSearchFilter
 * @param {string} props.searchText
 * @param {function} props.setSearchText
 * @returns {Element}
 * @constructor
 */
export default function HeaderFilter({ searchFilter, setSearchFilter, searchText, setSearchText }) {
  /**
   * @param {React.ChangeEvent<HTMLInputElement>} event
   */
  function handleFilterChange(event) {
    setSearchFilter(event.target.value);
  }

  /**
   * @param {React.KeyboardEvent<HTMLInputElement>} event
   */
  function handleSearchInputChange(event) {
    setSearchText(event.target.value);
  }

  /**
   * @param {React.MouseEvent<HTMLAnchorElement>} event
   */
  function handleSearchClear(event) {
    //TODO focus on textbox
    setSearchFilter("Product");
    setSearchText("");
  }

  return (<fieldset className="fieldSet">
    <legend className="legendOfFieldSet">Search</legend>
    <ul>
      <li>To search for a product, select the Product radio button and enter all or part of the product name.</li>
      <li>To search for a provider, select the Provider radio button and enter all or part of the Provider's name.
      </li>
      <li>To search all data within the table, select the All radio button and enter all or part of your search
        criteria.
      </li>
      <li>To clear your search and start over, select Clear Search.</li>
    </ul>
    <hr/>
    <div className="filterOptionsWrapper">
      <input type="radio" name="RadioBtn" value="Product" checked={searchFilter === "Product"} id="firstRadioBtn"
             className="searchModuleRadio" onChange={handleFilterChange}/>
      <label style={{ fontWeight: "normal", margin: 0 }} id="product" htmlFor="firstRadioBtn">
        Product
      </label>
      <input type="radio" name="RadioBtn" value="Provider" className="searchModuleRadio" id="provider"
             onChange={handleFilterChange} checked={searchFilter === "Provider"}/>
      <label style={{ fontWeight: "normal", margin: 0 }} htmlFor="provider">Provider</label>
      <input type="radio" name="RadioBtn" value="All" className="searchModuleRadio" id="all"
             onChange={handleFilterChange} checked={searchFilter === "All"}/>
      <label style={{ fontWeight: "normal", margin: 0 }} htmlFor="all">All</label>
      <br/>
      <span className="glyphicon glyphicon-search"></span>
      <input type="text" id="fedRampSearchBox" onChange={handleSearchInputChange} placeholder="Product Search..."
             aria-label="Product Search" title="Type in a product name" value={searchText}/>
      <Link className="clickable" onClick={handleSearchClear}>
        Clear Search
      </Link>
    </div>
  </fieldset>);
}

HeaderFilter.propTypes = {
  searchFilter: PropTypes.string.isRequired,
  setSearchFilter: PropTypes.func.isRequired,
  searchText: PropTypes.string.isRequired,
  setSearchText: PropTypes.func.isRequired,
};